import React from 'react'
import './Title.css'

const STYLES = [
  'title--primary',
  'title--trans',
  'title--opa',
  'title--pars',
  'title--title2',
  'title--title3',
]

const SIZES = ['title--small', 'title--medium', 'title--large']

export const Title = ({ children, type, onClick, titleStyle, titleSize }) => {
  const checkTitleStyle = STYLES.includes(titleStyle) ? titleStyle : STYLES[0]

  const checkTitleSize = SIZES.includes(titleSize) ? titleSize : SIZES[0]

  return (
    <h1
      className={`title ${checkTitleStyle} ${checkTitleSize}`}
      onClick={onClick}
      type={type}
    >
      {children}
    </h1>
  )
}
